import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal")

  return (_ctx.modelValue !== null)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: _ctx.title
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.description, (paragraph, i) => {
            return (_openBlock(), _createBlock("p", {
              key: i,
              textContent: _toDisplayString(paragraph)
            }, null, 8, ["textContent"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}